// window.gsap = gsap;
// gsap.defaults({
// 	overwrite: 'auto',
// });

import { initVevet } from 'vevet';
initVevet();

const HTML_CLASSLIST = document.documentElement.classList;

class RitmApp {
	constructor() {
		// this.env = require('./utils/env').default;
		// this.utils = require('./utils/utils').default;
		this.classes = {};
		this.modules = {
			ThinGap: require('./modules/ThinGap').default,
			CopyText: require('./modules/CopyText').default,
			Loader: require('./modules/Loader').default,
			Fade: require('./modules/Fade').default,
			LazyAnimation: require('./modules/LazyAnimation').default,
		};
		this.components = {
			Card: require('../../components/card/card').default,
			Input: require('../../components/input/input').default,
			Collections: require('../../components/collections/collections').default,
			Dropdown: require('../../components/dropdown/dropdown').default,
			Select: require('../../components/select/select').default,
			Modals: require('../../components/modals/modals').default,
			Popups: require('../../components/popups/popups').default,
			HeroCollection: require('../../components/hero-collection/hero-collection').default,
			Accordion: require('../../components/accordion/accordion').default,
			Counter: require('../../components/counter/counter').default,
			Tabs: require('../../components/tabs/tabs').default,
			// PopupSorting: require('../../includes/popups/popup-sorting').default,
			Product: require('../../includes/product/product').default,
			Gallery: require('../../components/gallery/gallery').default,
			Unpacking: require('../../includes/unpacking/unpacking').default,
			TooltipButton: require('../../components/tooltip-button/tooltip-button').default,
			ProductRecomended: require('../../includes/product-recomended/product-recomended').default,
			Toast: require('../../components/toast/toast').default,
			Barcode: require('../../includes/barcode/barcode').default,
			InputSmsCode: require('../../components/input-sms-code/input-sms-code').default,
			ShowMore: require('../../components/show-more/show-more').default,
			PopupLoyalty: require('../../includes/popups/popup-loyalty').default,
			EditOrder: require('../../includes/popups/edit-order').default,
			BottomPrice: require('../../components/bottom-price/bottom-price').default,
			Order: require('../../includes/order/order').default,
			OrderAuth: require('../../includes/order/order-auth').default,
			Tabbar: require('../../includes/tabbar/tabbar').default,
			OrderDelivery: require('../../includes/order/order-delivery').default,
			OrderRecipient: require('../../includes/order/order-recipient').default,
			OrderPayment: require('../../includes/order/order-payment').default,
			EditTel: require('../../includes/popups/edit-tel').default,
			Profile: require('../../includes/profile/profile').default,
			MainSliderBanner: require('../../includes/main/main-slider-banner').default,
			MainHoverSlider: require('../../includes/main/main-hover-slider').default,
			Location: require('../../includes/location/location').default,
			Menu: require('../../includes/menu/menu').default,
			Search: require('../../includes/search/search').default,
			CustomersNav: require('../../includes/customers-nav/customers-nav').default,
			Cookies: require('../../includes/cookies/cookies').default,
			BannerVinyl: require('../../includes/banner-vinyl/banner-vinyl').default,
			CustomScroll: require('../../components/custom-scroll/custom-scroll').default,
			PaymentTimer: require('../../components/payment-timer/payment-timer').default,
			CertificateCheckout: require('../../includes/certificate-checkout/certificate-checkout').default,
		};
		this.helpers = {
			GrabScroll: require('./helpers/GrabScroll').default,
		};

		window.addEventListener('load', () => {
			HTML_CLASSLIST.remove('_loading');

			const hash = window.location.hash;
			if (hash) {
				const popupName = hash.substring(1);
				const popup = this.components.Popups.getPopup(popupName);

				if (popup) {
					this.components.Popups.open(popupName);
				}
			}

			document.addEventListener('touchmove', () => {
				document.body.classList.add('disable-active');
			});

			document.addEventListener('touchend', () => {
				document.body.classList.remove('disable-active');
			});

			document.addEventListener('touchcancel', () => {
				document.body.classList.remove('disable-active');
			});
		});
	}
}

window.RitmApp = new RitmApp();
